'use client'
import React, { ReactNode, Suspense, useContext } from 'react'
import { LoggedInLayout } from '@layout/loggedInLayout'
import { observer } from 'mobx-react-lite'
import { RootStoreContext } from '@stores/rootStore'

const layout = function Layout({
  header,
  traceability,
  production,
  planting,
}: {
  children: ReactNode
  header: ReactNode
  traceability: ReactNode
  production: ReactNode
  planting: ReactNode
}) {
  const { uiStore } = useContext(RootStoreContext)

  return (
    <Suspense>
      <LoggedInLayout className={`bg-white p-2`} sidebarActiveTab="overview">
        <div className="flex h-full flex-col gap-y-4" data-testid="overview">
          {header}
          {/* currently on mobile there is a separate header which offset messes with the scroll */}
          <div
            className={`
              flex-1 overflow-x-auto pb-16
              md:p-10 md:py-8
              lg:pb-0
              print:overflow-visible
            `}
          >
            {production}
            {planting}
            {uiStore.currentOrganization?.hasTraceabilityFeature &&
              traceability}
          </div>
        </div>
      </LoggedInLayout>
    </Suspense>
  )
}

export default observer(layout)
